function getDiscountList({ data }) {
  return (data?.discounts ?? []).map((discount) => ({
    name: discount.name,
    code: discount.code,
  }));
}

export default function bookingEstimateParseResource({ data }) {
  if (!data) {
    return null;
  }

  return {
    roomReference: data?.roomRef,
    channelId: data?.channelId,
    nature: data?.nature,
    source: data?.source,
    checkin: data?.checkin,
    checkout: data?.checkout,
    departure: data?.departure,
    arrival: data?.arrival,
    tripAmount: data?.tripAmount,
    insuranceAmount: data?.insuranceAmount,
    reducedMarkupAmount: data?.reducedMarkupAmount,
    serviceFeeAmount: data?.serviceFeeAmount,
    baseServiceFeeAmount: data?.baseServiceFeeAmount,
    commissionDiscountsAmount: data?.commissionDiscountsAmount,
    markupDiscountsAmount: data?.markupDiscountsAmount,
    touristTaxAmount: data?.touristTaxAmount,
    duration: data?.metas?.duration,
    periodsAmountWithoutDiscounts: data?.metas?.periodsAmountWithoutDiscounts,
    customerPeriodsAmountWithoutDiscounts:
      data?.metas?.customerPeriodsAmountWithoutDiscounts,
    discountsAmount: data?.discountsAmount,
    discountList: getDiscountList({ data }),
    optionList: data?.options ?? [],
    discountServiceFeeAmount: data?.discountServiceFeeAmount,
    advanceAmount: data?.metas?.advance?.amount,
    advanceMaxDueDate: data?.metas?.advance?.dueDate,
    adults: data?.adults,
    childs: data?.childs,
    babies: data?.babies,
    pets: data?.pets,
    cats: data?.cats,
    dogs: data?.dogs,
    metas: {
      discount: data?.metas?.discount,
      customerDiscountsAmount: data?.metas?.customerDiscountsAmount,
      insuranceBaseAmount: data?.metas?.insuranceBaseAmount,
    },
    periodsAmount: data?.periodsAmount,
    optionsAmount: data?.optionsAmount,
  };
}
